// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { IconWrapper } from "@insite/mobius/Icon";
import ModalPresentationPropsDefault from "@insite/mobius/Modal/presentationProps";
import { getProp } from "@insite/mobius/utilities";
import { ModalPresentationProps } from "@plumberssupply/MobiusOverrides/Modal/Modal";
import { xBaseTheme } from "@plumberssupply/XDL/types";
import { color, styledScrollbar, xScreen } from "@plumberssupply/XDL/Utilities";
import { css } from "styled-components";

export default {
    sizeVariants: {
        small: 350,
        medium: 720,
        large: 1200,
    },
    defaultProps: {
        ...ModalPresentationPropsDefault,
        mergeCss: true,
        cssOverrides: {
            headlineTypography: css`
                margin-bottom: 0;
                letter-spacing: 0;
                color: ${color("common.ui11")};
            `,
            modalTitle: css`
                position: relative;
                padding: 18px 18px 9px;
                border-bottom: 0;
            `,
            modalContent: css`
                padding: 9px 18px 18px;
                ${styledScrollbar()}
            `,
            modalBody: css`
                background-color: ${color("common.white")};
                box-shadow: 0 2px 15px 0 ${color("common.ui10", 0.5)};
                overflow: visible;

                // Delete this media query for a full-screen modal on mobile
                ${xScreen("lte", "md")} {
                    max-width: calc(100% - 40px);
                    height: auto;
                    max-height: calc(100% - 35px);
                    margin: 15px;
                }
            `,
        },
        headlineTypographyProps: {
            size: 24,
            weight: 800,
            lineHeight: "26px",
        },
        closeButtonProps: {
            mergeCss: true,
            css: css`
                display: flex;
                align-items: center;
                justify-content: center;

                position: absolute;
                top: -13px;
                right: -13px;
                margin: 0;
                border: 3px solid ${color("common.white")};
                background-color: ${color("danger.main")};
                border-radius: 50%;
                width: 42px;
                height: 42px;
                min-height: initial;
                padding: 0;
                border: 3px solid ${color("common.white")};
                background-color: ${color("secondary")};
                box-shadow: 0 0 4px 0 ${color("common.ui10", 0.5)};
                z-index: 1;

                & > ${IconWrapper} {
                    position: unset;
                    top: 0;
                    &,
                    svg {
                        color: ${color("common.white")};
                        stroke-width: 4px;
                    }
                }

                &:hover {
                    border: 3px solid ${color("common.white")};
                    opacity: 0.8;
                }
                &:focus {
                    outline: none;
                }
            `,
        },
        closeButtonIconProps: {
            mergeCss: true,
            size: 20,
            color: "common.white",
            css: css`
                transition: all ${getProp("theme.transition.duration.regular")}ms ease-in-out;
            `,
        },
    } as ModalPresentationProps,
} as xBaseTheme["modal"];
